import { useEffect } from "react";

import { getNewPractices, updateSubgroupVariants } from "../utils";

export default function EditVariantsAssignment({
  isGroup,
  practicals,
  subgroupsCount,
  studentVariants,
  setStudentVariants,
  subgroupVariants,
  setSubgroupVariants,
}) {
  useEffect(() => {
    const setVariantsCount = (arr, func) => {
      const firstPractice = arr[0].practices?.[0];
      if (firstPractice && !firstPractice.variantsCount) {
        func((prev) =>
          prev.map((p) => ({
            ...p,
            practices: p.practices.map((elem) => {
              const variantsCount =
                practicals.find((item) => item.number === elem.number)
                  ?.variantsCount || 1;
              return { ...elem, variantsCount };
            }),
          })),
        );
      } else {
        func((prev) =>
          prev.map((p, i) => ({
            ...p,
            practices: getNewPractices(i, p.practices, practicals),
          })),
        );
      }
    };

    if (studentVariants.length) {
      setVariantsCount(studentVariants, setStudentVariants);
    }
    if (subgroupVariants.length) {
      setVariantsCount(subgroupVariants, setSubgroupVariants);
    }
  }, [practicals]);

  useEffect(() => {
    if (isGroup && subgroupsCount !== subgroupVariants.length) {
      updateSubgroupVariants(subgroupsCount, practicals, setSubgroupVariants);
    }
  }, [subgroupsCount]);

  const updateStudentVariant = (studentId, number, variant) =>
    setStudentVariants((prev) =>
      prev.map((p) =>
        p.studentId === studentId
          ? {
              ...p,
              practices: p.practices.map((elem) =>
                elem.number === number ? { ...elem, variant } : elem,
              ),
            }
          : p,
      ),
    );

  const updateSubgroupVariant = (subgroupNumber, number, variant) =>
    setSubgroupVariants((prev) =>
      prev.map((p) =>
        p.subgroupNumber === subgroupNumber
          ? {
              ...p,
              practices: p.practices.map((elem) =>
                elem.number === number ? { ...elem, variant } : elem,
              ),
            }
          : p,
      ),
    );

  const getPracticalColumns = (arr, onChange) =>
    arr.map((elem) => (
      <td key={elem.number}>
        <select
          value={elem.variant}
          onChange={(e) => onChange(elem.number, Number(e.target.value))}
        >
          {Array.from(
            {
              length: elem.variantsCount,
            },
            (_, i) => i + 1,
          ).map((n) => (
            <option key={n} value={n}>
              Вариант {n}
            </option>
          ))}
        </select>
      </td>
    ));

  const studentVariantsRows = studentVariants.map((v) => (
    <tr key={v.studentId} className="variants-row">
      <td className="student">{v.fullName}</td>
      {getPracticalColumns(v.practices, (number, value) =>
        updateStudentVariant(v.studentId, number, value),
      )}
    </tr>
  ));

  const subgroupVariantsRows = subgroupVariants.map((v) => (
    <tr key={v.subgroupNumber} className="variants-row">
      <td className="num-cell">{v.subgroupNumber}</td>
      {getPracticalColumns(v.practices, (number, value) =>
        updateSubgroupVariant(v.subgroupNumber, number, value),
      )}
    </tr>
  ));

  const renderTable = (firstColumnHeader, variantsRows) => (
    <table className="mini-table">
      <thead>
        <tr>
          <th>{firstColumnHeader}</th>
          {practicals.map((p) => (
            <th key={p.number}>{`Работа ${p.number}`}</th>
          ))}
        </tr>
      </thead>
      <tbody>{variantsRows}</tbody>
    </table>
  );

  return (
    <div className="subpanel">
      <div className="field-label">
        {`Распределение вариантов по ${isGroup ? "подгруппам" : "студентам"}`}
      </div>
      {studentVariants.length > 0 &&
        renderTable("Студент", studentVariantsRows)}
      {subgroupVariants.length > 0 &&
        renderTable("Подгруппа", subgroupVariantsRows)}
    </div>
  );
}
